
import { createSlice } from '@reduxjs/toolkit';
import { signOut } from '../../lib/authenticationLibrary';
import { getAuthPropSSO, setAuthPropsSSO } from '../../utils/Cookies/CookieHandler';


// const authenticateUser = createAsyncThunk("authSlice/authentication", async(authData)=>{

//   dispatch(authSlice.actions.login(authData));

// });

const authData = getAuthPropSSO();

if (authData?.user && !authData.user.userDisplayName && authData.user.firstName && authData.user.lastName) {
  authData.user.userDisplayName = `${authData.user.firstName} ${authData.user.lastName}`;
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isAuthenticated: (authData?.isAuthenticated != null),
    user: (authData?.user), //Set user data from cookie.
    token: (authData?.token), //Set token data from cookie.
    authData,
    isLogedin: false
  },
  reducers: {
    authentication: (state, action) => {
      let payload = action.payload;
      if (payload?.user && !payload.user.userDisplayName && payload.user.firstName && payload.user.lastName) {
        payload = {
          ...payload,
          user: {
            ...payload.user,
            userDisplayName: `${payload.user.firstName} ${payload.user.lastName}`
          }
        };
      }
      //Use to create cookie.
      setAuthPropsSSO(payload);
      state.isLogedin = true;
      state.isAuthenticated = payload?.isAuthenticated;
      state.user = payload?.user;
      state.token = payload?.token;
      state.authData = payload;
    },
    logout: (state) => {
      state.isLogedin = false;
      signOut();
    },
  },
});

export const { authentication, logout } = authSlice.actions;

export default authSlice.reducer;
